import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Campange } from '../../types';

export type State = Campange[];

const initialState: State = [];

export const CampangeSlice = createSlice({
  name: 'campanges',
  initialState,
  reducers: {
    onSetCampange: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeleteCampange: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetCampange, onDeleteCampange } = CampangeSlice.actions;

export default CampangeSlice.reducer;
